var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147_961)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_147_961)",
    d: "M144.757 223.193C139.696 229.566 129.434 226.074 129.312 217.936L127.529 98.9075H207.564C222.06 98.9075 230.145 115.651 221.131 127.004L144.757 223.193Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_147_961)",
    fillOpacity: 0.2,
    d: "M144.757 223.193C139.696 229.566 129.434 226.074 129.312 217.936L127.529 98.9075H207.564C222.06 98.9075 230.145 115.651 221.131 127.004L144.757 223.193Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3ECF8E",
    d: "M112.207 31.6655C117.268 25.2914 127.53 28.784 127.652 36.9221L128.434 155.951H49.4003C34.9034 155.951 26.8182 139.207 35.8328 127.854L112.207 31.6655Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_961",
    x1: 127.529,
    x2: 198.661,
    y1: 125.299,
    y2: 155.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_147_961",
    x1: 95.993,
    x2: 128.433,
    y1: 82.12,
    y2: 143.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192.92,
    height: 200,
    fill: "#fff",
    transform: "translate(32 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupabase);
export default __webpack_public_path__ + "static/media/supabase.b589129148f63fdd5bb889ec39e4eb6b.svg";
export { ForwardRef as ReactComponent };